var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

// src/components/Artboard.tsx
import { observer as observer3 } from "mobx-react";
import React3 from "react";

// src/components/draw/SvgRect.tsx
import { observer } from "mobx-react";
import PropTypes2 from "prop-types";
import React, { useCallback } from "react";

// src/prop-types/blendMode.ts
import PropTypes from "prop-types";
var blendMode_default = PropTypes.oneOf([
  "normal",
  "darken",
  "multiply",
  "lighten",
  "dodge",
  "overlay",
  "soft-light",
  "hard-light",
  "difference",
  "exclusion",
  "hue",
  "saturation",
  "color",
  "luminosity"
]);

// src/components/helpers/roundedRectHelpers.ts
function createPathString({
  w: w2,
  h: h2,
  x: x2,
  y: y2,
  radius,
  scale
}) {
  const [xScaling, yScaling] = scale;
  const [r0, r1, r2, r3] = radius;
  const move = `M ${x2 + r0 * xScaling} ${y2} `;
  const top = `h ${w2 - (r0 * xScaling + r1 * xScaling)} q ${r1 * xScaling} 0 ${r1 * xScaling} ${r1 * yScaling} `;
  const right = `v ${h2 - (r1 * yScaling + r2 * yScaling)} q 0 ${r2 * yScaling} -${r2 * xScaling} ${r2 * yScaling} `;
  const bottom = `h -${Math.max(w2 - (r2 * xScaling + r3 * xScaling), 0)} q -${r3 * xScaling} 0 -${r3 * xScaling} -${r3 * yScaling} `;
  const left = `v -${Math.max(h2 - (r0 * yScaling + r3 * yScaling), 0)} q 0 -${r0 * yScaling} ${r0 * xScaling} -${r0 * yScaling} z`;
  return move.concat(top, right, bottom, left);
}
function capRadius([topLeft, topRight, bottomRight, bottomLeft], [width, height]) {
  const reductionFactor = Math.min(width / (topLeft + topRight), height / (topRight + bottomRight), width / (bottomLeft + bottomRight), height / (topLeft + bottomLeft), 1);
  return [
    topLeft * reductionFactor,
    topRight * reductionFactor,
    bottomRight * reductionFactor,
    bottomLeft * reductionFactor
  ];
}

// src/components/draw/SvgRect.tsx
function useStrokeAdjustedRectangle() {
  return useCallback(({
    x: x2,
    y: y2,
    width,
    height,
    globalMatrixCache,
    strokePosition,
    strokeWidth,
    radius = [0, 0, 0, 0]
  }) => {
    let strokeAdjustedHeight = height;
    let strokeAdjustedWidth = width;
    let adjustedX = x2;
    let adjustedY = y2;
    let adjustedRadius = radius;
    if (strokePosition === "inside") {
      const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
      const adjustedStrokeWidth = strokeWidth;
      strokeAdjustedWidth = Math.max(width - strokeWidth / globalMatrixScalingX, width / 2);
      strokeAdjustedHeight = Math.max(height - strokeWidth / globalMatrixScalingY, height / 2);
    } else if (strokePosition === "outside") {
      const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
      const adjustedStrokeWidth = strokeWidth;
      strokeAdjustedWidth = Math.max(width + strokeWidth / globalMatrixScalingX, width / 2);
      strokeAdjustedHeight = Math.max(height + strokeWidth / globalMatrixScalingY, height / 2);
    }
    const widthDelta = width - strokeAdjustedWidth;
    const heightDelta = height - strokeAdjustedHeight;
    adjustedX += widthDelta / 2;
    adjustedY += heightDelta / 2;
    if (radius && (width !== strokeAdjustedWidth || height !== strokeAdjustedHeight)) {
      const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
      adjustedRadius = capRadius(radius, [
        strokeAdjustedWidth * globalMatrixScalingX,
        strokeAdjustedHeight * globalMatrixScalingY
      ]);
    }
    return {
      x: adjustedX,
      y: adjustedY,
      width: strokeAdjustedWidth,
      height: strokeAdjustedHeight,
      radius: adjustedRadius
    };
  }, []);
}
var SvgRect = ({
  fill,
  fillRule,
  filter,
  globalMatrixCache,
  height,
  mixBlendMode,
  rx,
  ry,
  stroke,
  strokeDasharray,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokePosition,
  strokeWidth,
  width,
  x: x2,
  y: y2
}) => {
  const strokeAdjustedRectangle = useStrokeAdjustedRectangle();
  const {
    x: adjustedX,
    y: adjustedY,
    width: strokeAdjustedWidth,
    height: strokeAdjustedHeight
  } = strokeAdjustedRectangle({
    x: x2,
    y: y2,
    width,
    height,
    globalMatrixCache,
    strokePosition,
    strokeWidth
  });
  return /* @__PURE__ */ React.createElement("rect", {
    fill,
    fillRule,
    filter,
    height: strokeAdjustedHeight,
    rx,
    ry,
    stroke,
    strokeDasharray,
    strokeLinecap,
    strokeLinejoin,
    strokeMiterlimit,
    strokeWidth,
    style: {
      mixBlendMode
    },
    vectorEffect: "non-scaling-stroke",
    width: strokeAdjustedWidth,
    x: adjustedX,
    y: adjustedY
  });
};
SvgRect.propTypes = {
  fill: PropTypes2.string,
  fillRule: PropTypes2.string,
  height: PropTypes2.number,
  mixBlendMode: blendMode_default,
  rx: PropTypes2.number,
  ry: PropTypes2.number,
  stroke: PropTypes2.string,
  strokeDasharray: PropTypes2.string,
  strokeLinecap: PropTypes2.string,
  strokeLinejoin: PropTypes2.string,
  strokeMiterlimit: PropTypes2.number,
  strokeWidth: PropTypes2.number,
  width: PropTypes2.number,
  x: PropTypes2.number,
  y: PropTypes2.number
};
SvgRect.defaultProps = {
  fill: "none",
  fillRule: void 0,
  height: 0,
  mixBlendMode: "normal",
  rx: 0,
  ry: 0,
  stroke: "none",
  strokeDasharray: void 0,
  strokeLinecap: void 0,
  strokeLinejoin: void 0,
  strokeMiterlimit: void 0,
  strokeWidth: 0,
  width: 0,
  x: 0,
  y: 0
};
var SvgRect_default = observer(SvgRect);

// src/components/helpers/Fills.tsx
import { observer as observer2 } from "mobx-react";
import React2 from "react";
import {
  FillUtils,
  MatrixUtils,
  PropertyClass
} from "@marvelapp/design-creator";
import { useDesign } from "@marvelapp/plugin-design";

// src/components/hooks/useGetUrlAlias.ts
import { createContext, useContext } from "react";
var GetUrlAliasContext = createContext(void 0);
function useGetUrlAlias() {
  return useContext(GetUrlAliasContext);
}

// src/components/helpers/Fills.tsx
var Fills_default = observer2((_a) => {
  var _b = _a, { Component } = _b, props = __objRest(_b, ["Component"]);
  const _a2 = props, { id, fillStyle } = _a2, otherProps = __objRest(_a2, ["id", "fillStyle"]);
  if (fillStyle === void 0)
    return null;
  const { fillRule, fills } = fillStyle;
  const fillComponents = fills.map((fill, fillIndex) => {
    const { blendMode, content, enabled } = fill;
    if (!enabled)
      return null;
    switch (content.className) {
      case PropertyClass.Color: {
        const [r2, g2, b2, a2] = content.rgbaValues;
        return /* @__PURE__ */ React2.createElement(Component, __spreadProps(__spreadValues({}, otherProps), {
          fill: `rgba(${r2 * 255},${g2 * 255},${b2 * 255},${a2})`,
          fillRule,
          key: `fill-${fillIndex}`,
          mixBlendMode: blendMode
        }));
      }
      case PropertyClass.Gradient: {
        const { from, stops, type, to } = content;
        if (type === "linear") {
          const gradientId = `${id}-gradient-${fillIndex}`;
          return /* @__PURE__ */ React2.createElement(React2.Fragment, {
            key: `fill-${fillIndex}`
          }, /* @__PURE__ */ React2.createElement("defs", null, /* @__PURE__ */ React2.createElement("linearGradient", {
            id: gradientId,
            x1: from[0],
            x2: to[0],
            y1: from[1],
            y2: to[1]
          }, stops.map(({ color, stopPosition }, stopIndex) => {
            const [r2, g2, b2, a2] = color.rgbaValues;
            return /* @__PURE__ */ React2.createElement("stop", {
              key: `stop-${stopIndex}`,
              offset: `${100 * stopPosition}%`,
              stopColor: `rgba(${r2 * 255},${g2 * 255},${b2 * 255},${a2})`
            });
          }))), /* @__PURE__ */ React2.createElement(Component, __spreadProps(__spreadValues({}, otherProps), {
            fill: `url(#${gradientId})`,
            fillRule,
            key: `fill-${fillIndex}`,
            mixBlendMode: blendMode
          })));
        }
        return null;
      }
      case PropertyClass.Pattern:
        if (FillUtils.isTokenInstanceFill(fill)) {
          return /* @__PURE__ */ React2.createElement(TokenFill, __spreadValues({
            Component,
            fill,
            fillRule
          }, otherProps));
        }
        return /* @__PURE__ */ React2.createElement(PatternFill, __spreadValues({
          Component,
          fill,
          fillIndex,
          fillRule,
          id
        }, otherProps));
      default: {
        return null;
      }
    }
  });
  return fillComponents;
});
var PatternFill = observer2((_a) => {
  var _b = _a, { Component, fillIndex, id, fill, fillRule } = _b, componentProps = __objRest(_b, ["Component", "fillIndex", "id", "fill", "fillRule"]);
  const patternId = `${id}-pattern-${fillIndex}`;
  const {
    blendMode,
    content: { source, size: patternSize }
  } = fill;
  const { getItemById, getAncestorMatrix, getBounds } = useDesign();
  const getUrl = useGetUrlAlias();
  const patternUrl = getUrl(id, source);
  const {
    itemProps: { matrix: itemMatrix }
  } = getItemById(id);
  const ancestorMatrix = getAncestorMatrix(id);
  const itemBounds = getBounds(id, true);
  if (!itemBounds)
    return null;
  const widthRatio = patternSize[0] / itemBounds.size[0];
  const heightRatio = patternSize[1] / itemBounds.size[1];
  let x2;
  let y2;
  let patternWidth;
  let patternHeight;
  let imageWidth;
  let imageHeight;
  if (widthRatio < heightRatio) {
    [imageWidth] = itemBounds.size;
    const height = imageWidth / (patternSize[0] / patternSize[1]);
    const offset = (itemBounds.size[1] - height) / 2;
    [patternWidth] = itemBounds.size;
    patternHeight = itemBounds.size[1] - offset;
    [x2] = itemBounds.point;
    y2 = itemBounds.point[1] + offset;
  } else {
    [, imageHeight] = itemBounds.size;
    const width = itemBounds.size[1] * (patternSize[0] / patternSize[1]);
    const offset = (itemBounds.size[0] - width) / 2;
    patternWidth = itemBounds.size[1] - offset;
    [, patternHeight] = itemBounds.size;
    x2 = itemBounds.point[0] + offset;
    [, y2] = itemBounds.point;
  }
  const inverseMatrix = MatrixUtils.invert(MatrixUtils.multiply(ancestorMatrix, itemMatrix));
  return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement("defs", null, /* @__PURE__ */ React2.createElement("pattern", {
    height: patternHeight,
    id: patternId,
    patternTransform: `matrix(${inverseMatrix.join(",")})`,
    patternUnits: "userSpaceOnUse",
    width: patternWidth,
    x: x2,
    y: y2
  }, /* @__PURE__ */ React2.createElement("image", {
    height: imageHeight,
    href: patternUrl,
    width: imageWidth
  }))), /* @__PURE__ */ React2.createElement(Component, __spreadProps(__spreadValues({}, componentProps), {
    fill: `url(#${patternId})`,
    fillRule,
    key: `fill-${fillIndex}`,
    mixBlendMode: blendMode
  })));
});
function TokenFill(_a) {
  var _b = _a, { Component, fill, fillRule } = _b, otherProps = __objRest(_b, ["Component", "fill", "fillRule"]);
  const { blendMode, content } = fill;
  const id = content.source;
  const { getTokens } = useDesign();
  const token = getTokens()[id];
  if (!token || token.type !== "color")
    return null;
  const [r2, g2, b2, a2] = token.value.split(",");
  return /* @__PURE__ */ React2.createElement(Component, __spreadProps(__spreadValues({}, otherProps), {
    fill: `rgba(${Number(r2) * 255},${Number(g2) * 255},${Number(b2) * 255},${a2})`,
    fillRule,
    mixBlendMode: blendMode
  }));
}

// src/components/Artboard.tsx
var Artboard = observer3(({ data }) => {
  const { fills, size, point } = data;
  const [x2, y2] = point;
  const [width, height] = size;
  return /* @__PURE__ */ React3.createElement("g", {
    id: "artboard"
  }, /* @__PURE__ */ React3.createElement(Fills_default, {
    Component: SvgRect_default,
    fillStyle: {
      fillRule: "nonzero",
      fills
    },
    height,
    rx: 0,
    ry: 0,
    width,
    x: x2,
    y: y2
  }));
});

// src/components/CompoundPath.tsx
import { observer as observer8 } from "mobx-react";
import React8 from "react";
import { useDesign as useDesign2 } from "@marvelapp/plugin-design";

// src/components/Path.tsx
import { observer as observer7 } from "mobx-react";
import React7 from "react";
import {
  PathUtils as PathUtils2,
  PointUtils as PointUtils2
} from "@marvelapp/design-creator";

// src/components/DecoratedLine.tsx
import { cloneDeep } from "lodash-es";
import { observer as observer4 } from "mobx-react";
import React4 from "react";
import {
  ColorUtils,
  ItemUtils,
  MatrixUtils as MatrixUtils2,
  PathUtils,
  PointUtils,
  StrokeUtils
} from "@marvelapp/design-creator";
var DecoratedLine = observer4((_a) => {
  var _b = _a, { data, clipPathId } = _b, props = __objRest(_b, ["data", "clipPathId"]);
  const { closed, segments } = data;
  const normalizedSegments = normalizeSegments(segments);
  const cssColor = getColor(data);
  const decorationSize = getSize(data);
  const angle = getAngle(normalizedSegments);
  const adustedSegments = adjustSegments(normalizedSegments, decorationSize, angle);
  const pathProps = {
    d: segmentsToSVGPath(adustedSegments, closed)
  };
  const pathData = cloneDeep(data);
  PathUtils.mClearDecorations(pathData);
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(Path, __spreadProps(__spreadValues(__spreadValues({}, props), pathProps), {
    clipPathId,
    data: pathData
  })), /* @__PURE__ */ React4.createElement(EndDecoration, {
    angle,
    color: cssColor,
    end: normalizedSegments[1],
    size: decorationSize
  }));
});
function getColor(data) {
  const firstStroke = ItemUtils.getStrokes(data)[0];
  if (!firstStroke)
    return void 0;
  const color = StrokeUtils.getColor(firstStroke);
  return ColorUtils.getCssRgba(color);
}
function getSize(data) {
  const firstStroke = ItemUtils.getStrokes(data)[0];
  if (!firstStroke)
    return 0;
  const strokeWidth = StrokeUtils.getWidth(firstStroke);
  return strokeWidth * 5;
}
function getAngle([start, end]) {
  const tan = (end[1] - start[1]) / (start[0] - end[0]);
  let theta = Math.atan(tan);
  if (end[0] < start[0])
    theta += Math.PI;
  return theta;
}
function adjustSegments(normalizedSegments, size, angle) {
  const [start, end] = normalizedSegments;
  const sign = Math.abs(angle) !== Math.PI / 2 ? 1 : -1;
  const h2 = size * sign;
  const dx = h2 * Math.cos(angle);
  const dy = h2 * Math.sin(angle);
  return [start, [end[0] - dx / 2, end[1] + dy / 2]];
}
function EndDecoration({ color, size, angle, end }) {
  if (!color || !size)
    return null;
  const translated = MatrixUtils2.translate(MatrixUtils2.create(), [
    end[0] - size,
    end[1] - size / 2
  ]);
  const rotated = rotateArrow(translated, angle, end);
  return /* @__PURE__ */ React4.createElement("g", {
    transform: `matrix(${rotated.join(" ")})`
  }, /* @__PURE__ */ React4.createElement("path", {
    d: `M0 0 L${size} ${size / 2} L0 ${size} Z`,
    fill: color
  }));
}
function rotateArrow(matrix, theta, center) {
  if (theta === Math.PI / 2 || theta === -Math.PI / 2) {
    theta = -theta;
  }
  const rotationMatrix = MatrixUtils2.create(Math.cos(theta), -Math.sin(theta), Math.sin(theta), Math.cos(theta));
  const translateCenterToOrigin = MatrixUtils2.translate(matrix, PointUtils.negate(center));
  const translateBack = MatrixUtils2.translate(MatrixUtils2.create(), center);
  return MatrixUtils2.multiply(translateBack, MatrixUtils2.multiply(rotationMatrix, translateCenterToOrigin));
}

// src/components/draw/SvgPath.tsx
import { observer as observer5 } from "mobx-react";
import PropTypes3 from "prop-types";
import React5 from "react";
function SvgPath({
  d: d2,
  fill,
  fillRule,
  filter,
  mixBlendMode,
  opacity,
  stroke,
  strokeDasharray,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokeWidth
}) {
  return /* @__PURE__ */ React5.createElement("path", {
    d: d2,
    fill,
    fillRule,
    filter,
    opacity,
    stroke,
    strokeDasharray,
    strokeLinecap,
    strokeLinejoin,
    strokeMiterlimit,
    strokeWidth,
    style: {
      mixBlendMode
    },
    vectorEffect: "non-scaling-stroke"
  });
}
SvgPath.propTypes = {
  d: PropTypes3.string,
  fill: PropTypes3.string,
  fillRule: PropTypes3.string,
  mixBlendMode: blendMode_default,
  stroke: PropTypes3.string,
  strokeDasharray: PropTypes3.string,
  strokeLinecap: PropTypes3.string,
  strokeLinejoin: PropTypes3.string,
  strokeMiterlimit: PropTypes3.number,
  strokeWidth: PropTypes3.number
};
SvgPath.defaultProps = {
  d: "",
  fill: "none",
  fillRule: void 0,
  mixBlendMode: "normal",
  stroke: "none",
  strokeDasharray: void 0,
  strokeLinecap: void 0,
  strokeLinejoin: void 0,
  strokeMiterlimit: void 0,
  strokeWidth: 0
};
var SvgPath_default = observer5(SvgPath);

// src/components/helpers/Strokes.tsx
import { observer as observer6 } from "mobx-react";
import React6 from "react";
var Strokes = observer6((_a) => {
  var _b = _a, {
    Component,
    data,
    ignoreZoom
  } = _b, componentProps = __objRest(_b, [
    "Component",
    "data",
    "ignoreZoom"
  ]);
  const { strokes, strokeStyle } = data;
  const { dashArray, miterLimit, strokeCap, strokeJoin } = strokeStyle;
  const strokeComponents = strokes.map((stroke, i2) => {
    const { color, strokePosition, width, enabled } = stroke;
    if (!enabled)
      return null;
    switch (color.className) {
      case "Color": {
        const [r2, g2, b2, a2] = color.rgbaValues;
        const strokeWidth = ignoreZoom ? width : width;
        return /* @__PURE__ */ React6.createElement(Component, __spreadProps(__spreadValues({}, componentProps), {
          key: `stroke-${i2}`,
          stroke: `rgba(${r2 * 255},${g2 * 255},${b2 * 255},${a2})`,
          strokeDasharray: dashArray.join(","),
          strokeLinecap: strokeCap,
          strokeLinejoin: strokeJoin,
          strokeMiterlimit: miterLimit,
          strokePosition,
          strokeWidth
        }));
      }
      default: {
        return React6.Fragment;
      }
    }
  });
  return strokeComponents;
});

// src/components/Path.tsx
var Path = observer7((_a) => {
  var _b = _a, { clipPathId, data, ignoreZoom } = _b, props = __objRest(_b, ["clipPathId", "data", "ignoreZoom"]);
  if (PathUtils2.isDecoratedLine(data)) {
    return /* @__PURE__ */ React7.createElement(DecoratedLine, __spreadProps(__spreadValues({}, props), {
      clipPathId,
      data
    }));
  }
  const d2 = elementToSVGPath(data);
  return /* @__PURE__ */ React7.createElement(DPath, __spreadProps(__spreadValues({}, props), {
    d: d2,
    data
  }));
});
var DPath = observer7(({ d: d2, data, clipPathId, ignoreZoom }) => {
  const { id } = data;
  if (!d2)
    return null;
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, clipPathId && /* @__PURE__ */ React7.createElement("clipPath", {
    id: clipPathId
  }, /* @__PURE__ */ React7.createElement(SvgPath_default, {
    d: d2
  })), /* @__PURE__ */ React7.createElement(Fills_default, {
    Component: SvgPath_default,
    fillStyle: data.fillStyle,
    id,
    d: d2
  }), /* @__PURE__ */ React7.createElement(Strokes, {
    Component: SvgPath_default,
    data,
    d: d2
  }));
});
function elementToSVGPath(element, matrix) {
  const { closed, segments } = element;
  const normalizedSegments = normalizeSegments(segments, matrix);
  if (normalizedSegments.length === 0)
    return "";
  return segmentsToSVGPath(normalizedSegments, closed);
}
function normalizeSegments(segments, matrix) {
  return segments.map((segment) => {
    const [x2, y2] = matrix ? PointUtils2.transform([segment[0], segment[1]], matrix) : segment;
    if (segment.length === 6) {
      const [, , x1, y1, x22, y22] = segment;
      return [
        x2,
        y2,
        x1 + x2,
        y1 + y2,
        x22 + x2,
        y22 + y2
      ];
    }
    return [x2, y2];
  });
}
function segmentsToSVGPath(segments, closed) {
  const lines = segmentsToLines(segments, closed);
  const svgLines = lines.map(([segmentA, segmentB]) => {
    const { p1, p2, p3 } = segmentsToBezier(segmentA, segmentB);
    return `C${p1[0]} ${p1[1]}, ${p2[0]} ${p2[1]}, ${p3[0]} ${p3[1]}`;
  }).join(" ");
  const [x2, y2] = segments[0];
  return `M${x2} ${y2} ${svgLines} ${closed ? "Z" : ""}`;
}
function segmentsToLines(segments, closed) {
  const lines = [];
  for (let i2 = 0; i2 < segments.length - 1; i2 += 1) {
    const segmentA = segments[i2];
    const segmentB = segments[i2 + 1];
    lines.push([segmentA, segmentB]);
  }
  if (closed) {
    const segmentA = segments[segments.length - 1];
    const segmentB = segments[0];
    lines.push([segmentA, segmentB]);
  }
  return lines;
}
function segmentsToBezier(segmentA, segmentB) {
  const [p0x, p0y, , , p1x, p1y] = addAnchors(segmentA);
  const [p3x, p3y, p2x, p2y] = addAnchors(segmentB);
  return {
    p0: [p0x, p0y],
    p1: [p1x, p1y],
    p2: [p2x, p2y],
    p3: [p3x, p3y]
  };
}
function addAnchors(segment) {
  if (segment.length === 6) {
    return segment;
  }
  const [x2, y2] = segment;
  return [x2, y2, x2, y2, x2, y2];
}

// src/components/CompoundPath.tsx
var CompoundPath = observer8((props) => {
  const { getItemById } = useDesign2();
  const d2 = collapseToSVGPath(props.data, getItemById);
  return /* @__PURE__ */ React8.createElement(DPath, __spreadProps(__spreadValues({}, props), {
    d: d2
  }));
});
function collapseToSVGPath(item, getItemById) {
  if (item.className === "CompoundPath") {
    return item.children.map((id) => {
      const child = getItemById(id);
      return collapseToSVGPath(child, getItemById);
    }).join(" ");
  }
  return elementToSVGPath(item, item.itemProps.matrix);
}

// src/components/Design.tsx
import { observer as observer25 } from "mobx-react";
import React30, { useCallback as useCallback3, useState } from "react";

// ../../node_modules/.store/react-shadow-virtual-b4602a0266/node_modules/react-shadow/react-shadow.esm.js
import e, { useRef as r, useEffect as t, createContext as n, forwardRef as o, useState as a, useContext as c } from "react";
import { createPortal as u } from "react-dom";
import i from "prop-types";
var l = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function s(e2, r2) {
  return e2(r2 = { exports: {} }, r2.exports), r2.exports;
}
var f = s(function(e2) {
  !function(r2) {
    var t2 = function(e3, r3, n3) {
      if (!i2(r3) || s2(r3) || f2(r3) || p2(r3) || u2(r3))
        return r3;
      var o3, a3 = 0, c3 = 0;
      if (l2(r3))
        for (o3 = [], c3 = r3.length; a3 < c3; a3++)
          o3.push(t2(e3, r3[a3], n3));
      else
        for (var d3 in o3 = {}, r3)
          Object.prototype.hasOwnProperty.call(r3, d3) && (o3[e3(d3, n3)] = t2(e3, r3[d3], n3));
      return o3;
    }, n2 = function(e3) {
      return d2(e3) ? e3 : (e3 = e3.replace(/[\-_\s]+(.)?/g, function(e4, r3) {
        return r3 ? r3.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + e3.substr(1);
    }, o2 = function(e3) {
      var r3 = n2(e3);
      return r3.substr(0, 1).toUpperCase() + r3.substr(1);
    }, a2 = function(e3, r3) {
      return function(e4, r4) {
        var t3 = (r4 = r4 || {}).separator || "_", n3 = r4.split || /(?=[A-Z])/;
        return e4.split(n3).join(t3);
      }(e3, r3).toLowerCase();
    }, c2 = Object.prototype.toString, u2 = function(e3) {
      return typeof e3 == "function";
    }, i2 = function(e3) {
      return e3 === Object(e3);
    }, l2 = function(e3) {
      return c2.call(e3) == "[object Array]";
    }, s2 = function(e3) {
      return c2.call(e3) == "[object Date]";
    }, f2 = function(e3) {
      return c2.call(e3) == "[object RegExp]";
    }, p2 = function(e3) {
      return c2.call(e3) == "[object Boolean]";
    }, d2 = function(e3) {
      return (e3 -= 0) == e3;
    }, y2 = function(e3, r3) {
      var t3 = r3 && "process" in r3 ? r3.process : r3;
      return typeof t3 != "function" ? e3 : function(r4, n3) {
        return t3(r4, e3, n3);
      };
    }, h2 = { camelize: n2, decamelize: a2, pascalize: o2, depascalize: a2, camelizeKeys: function(e3, r3) {
      return t2(y2(n2, r3), e3);
    }, decamelizeKeys: function(e3, r3) {
      return t2(y2(a2, r3), e3, r3);
    }, pascalizeKeys: function(e3, r3) {
      return t2(y2(o2, r3), e3);
    }, depascalizeKeys: function() {
      return this.decamelizeKeys.apply(this, arguments);
    } };
    e2.exports ? e2.exports = h2 : r2.humps = h2;
  }(l);
}).decamelize;
var p = s(function(e2) {
  function r2() {
    return e2.exports = r2 = Object.assign || function(e3) {
      for (var r3 = 1; r3 < arguments.length; r3++) {
        var t2 = arguments[r3];
        for (var n2 in t2)
          Object.prototype.hasOwnProperty.call(t2, n2) && (e3[n2] = t2[n2]);
      }
      return e3;
    }, r2.apply(this, arguments);
  }
  e2.exports = r2;
});
var d = function(e2) {
  if (Array.isArray(e2))
    return e2;
};
var y = function(e2, r2) {
  if (typeof Symbol != "undefined" && Symbol.iterator in Object(e2)) {
    var t2 = [], n2 = true, o2 = false, a2 = void 0;
    try {
      for (var c2, u2 = e2[Symbol.iterator](); !(n2 = (c2 = u2.next()).done) && (t2.push(c2.value), !r2 || t2.length !== r2); n2 = true)
        ;
    } catch (e3) {
      o2 = true, a2 = e3;
    } finally {
      try {
        n2 || u2.return == null || u2.return();
      } finally {
        if (o2)
          throw a2;
      }
    }
    return t2;
  }
};
var h = function(e2, r2) {
  (r2 == null || r2 > e2.length) && (r2 = e2.length);
  for (var t2 = 0, n2 = new Array(r2); t2 < r2; t2++)
    n2[t2] = e2[t2];
  return n2;
};
var v = function(e2, r2) {
  if (e2) {
    if (typeof e2 == "string")
      return h(e2, r2);
    var t2 = Object.prototype.toString.call(e2).slice(8, -1);
    return t2 === "Object" && e2.constructor && (t2 = e2.constructor.name), t2 === "Map" || t2 === "Set" ? Array.from(e2) : t2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? h(e2, r2) : void 0;
  }
};
var m = function() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var b = function(e2, r2) {
  return d(e2) || y(e2, r2) || v(e2, r2) || m();
};
var g = function(e2, r2) {
  if (e2 == null)
    return {};
  var t2, n2, o2 = {}, a2 = Object.keys(e2);
  for (n2 = 0; n2 < a2.length; n2++)
    t2 = a2[n2], r2.indexOf(t2) >= 0 || (o2[t2] = e2[t2]);
  return o2;
};
var S = function(e2, r2) {
  if (e2 == null)
    return {};
  var t2, n2, o2 = g(e2, r2);
  if (Object.getOwnPropertySymbols) {
    var a2 = Object.getOwnPropertySymbols(e2);
    for (n2 = 0; n2 < a2.length; n2++)
      t2 = a2[n2], r2.indexOf(t2) >= 0 || Object.prototype.propertyIsEnumerable.call(e2, t2) && (o2[t2] = e2[t2]);
  }
  return o2;
};
var w = n(null);
function O(e2) {
  var r2 = e2.root, t2 = e2.children;
  return u(t2, r2);
}
function j(n2) {
  var c2 = o(function(o2, c3) {
    var u2, i2, l2 = o2.mode, s2 = o2.delegatesFocus, f2 = o2.styleSheets, d2 = o2.ssr, y2 = o2.children, h2 = S(o2, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]), v2 = (i2 = r((u2 = c3) && u2.current), t(function() {
      u2 && (u2.current = i2.current);
    }, [u2]), i2), m2 = a(null), g2 = b(m2, 2), j2 = g2[0], x2 = g2[1], z = "node_".concat(l2).concat(s2);
    return t(function() {
      if (v2.current)
        try {
          if (typeof c3 == "function" && c3(v2.current), d2) {
            var e2 = v2.current.shadowRoot;
            return void x2(e2);
          }
          var r2 = v2.current.attachShadow({ mode: l2, delegatesFocus: s2 });
          f2.length > 0 && (r2.adoptedStyleSheets = f2), x2(r2);
        } catch (e3) {
          !function(e4) {
            var r3 = e4.error, t2 = e4.styleSheets, n3 = e4.root;
            switch (r3.name) {
              case "NotSupportedError":
                t2.length > 0 && (n3.adoptedStyleSheets = t2);
                break;
              default:
                throw r3;
            }
          }({ error: e3, styleSheets: f2, root: j2 });
        }
    }, [c3, v2, f2]), e.createElement(e.Fragment, null, e.createElement(n2.tag, p({ key: z, ref: v2 }, h2), (j2 || d2) && e.createElement(w.Provider, { value: j2 }, d2 ? e.createElement("template", { shadowroot: "open" }, n2.render({ root: j2, ssr: d2, children: y2 })) : e.createElement(O, { root: j2 }, n2.render({ root: j2, ssr: d2, children: y2 })))));
  });
  return c2.propTypes = { mode: i.oneOf(["open", "closed"]), delegatesFocus: i.bool, styleSheets: i.arrayOf(i.instanceOf(globalThis.CSSStyleSheet)), ssr: i.bool, children: i.node }, c2.defaultProps = { mode: "open", delegatesFocus: false, styleSheets: [], ssr: false, children: null }, c2;
}
O.propTypes = { root: i.object.isRequired, children: i.node }, O.defaultProps = { children: null };
var x = /* @__PURE__ */ new Map();
function E() {
  var e2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "core", t2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(e3) {
    return e3.children;
  };
  return new Proxy(e2, { get: function(e3, n2) {
    var o2 = f(n2, { separator: "-" }), a2 = "".concat(r2, "-").concat(o2);
    return x.has(a2) || x.set(a2, j({ tag: o2, render: t2 })), x.get(a2);
  } });
}
var A = E();
var react_shadow_esm_default = A;

// src/components/Design.tsx
import { PointUtils as PointUtils6 } from "@marvelapp/design-creator";
import { useComponents as useComponents8 } from "@marvelapp/design-renderer-base";
import { OverlayPortalProvider } from "@marvelapp/plugin-core";
import { useDesign as useDesign6 } from "@marvelapp/plugin-design";
import { WeakFontsProvider } from "@marvelapp/plugin-fonts";
import { WeakViewProvider, useView as useView2 } from "@marvelapp/plugin-view";

// src/components/ArtboardContainer.tsx
import React9 from "react";
import { useComponents } from "@marvelapp/design-renderer-base";
var ArtboardContainer = (props) => {
  const { Artboard: Artboard2 } = useComponents();
  return /* @__PURE__ */ React9.createElement(Artboard2, __spreadValues({}, props));
};

// src/components/Fonts.tsx
import { observer as observer9 } from "mobx-react";
import React10 from "react";
import { useComponents as useComponents2 } from "@marvelapp/design-renderer-base";
import { useFonts } from "@marvelapp/plugin-fonts";
var Fonts = observer9(() => {
  const elements = useComponents2();
  const { getFontFaces } = useFonts();
  return /* @__PURE__ */ React10.createElement(elements.Head, null, /* @__PURE__ */ React10.createElement("style", {
    type: "text/css"
  }, getFontFaces().map(({ fontFamily, fontStyle, fontWeight, src }) => `
            @font-face {
              font-family: "${fontFamily}";
              font-style: ${fontStyle};
              font-weight: ${fontWeight};
              src: ${src.map(({ url, format }) => `url("${url}") format("${format}")`).join(", ")};
            }
            `).join("")));
});

// src/components/context/DefaultComponentsProvider.tsx
import React29 from "react";
import { ComponentsProvider } from "@marvelapp/design-renderer-base";

// src/components/Ellipse.tsx
import { observer as observer11 } from "mobx-react";
import React12 from "react";

// src/components/draw/SvgEllipse.tsx
import { observer as observer10 } from "mobx-react";
import PropTypes4 from "prop-types";
import React11 from "react";
import { useView } from "@marvelapp/plugin-view";
function SvgEllipse({
  cx,
  cy,
  fill,
  filter,
  fillRule,
  globalMatrixCache,
  mixBlendMode,
  rx,
  ry,
  stroke,
  strokeDasharray,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokePosition,
  strokeWidth
}) {
  const view = useView();
  let strokeAdjustedRx = rx;
  let strokeAdjustedRy = ry;
  if (strokePosition === "inside") {
    const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache;
    const adjustedStrokeWidth = strokeWidth / view.zoomFactor / 2;
    strokeAdjustedRx = Math.max(rx - adjustedStrokeWidth / globalMatrixScalingX, rx / 4);
    strokeAdjustedRy = Math.max(ry - adjustedStrokeWidth / globalMatrixScalingY, ry / 4);
  } else if (strokePosition === "outside") {
    const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache;
    const adjustedStrokeWidth = strokeWidth / view.zoomFactor / 2;
    strokeAdjustedRx = Math.max(rx + adjustedStrokeWidth / globalMatrixScalingX, rx / 4);
    strokeAdjustedRy = Math.max(ry + adjustedStrokeWidth / globalMatrixScalingY, ry / 4);
  }
  return /* @__PURE__ */ React11.createElement("ellipse", {
    cx,
    cy,
    fill,
    fillRule,
    filter,
    rx: strokeAdjustedRx,
    ry: strokeAdjustedRy,
    stroke,
    strokeDasharray,
    strokeLinecap,
    strokeLinejoin,
    strokeMiterlimit,
    strokeWidth,
    style: {
      mixBlendMode
    },
    vectorEffect: "non-scaling-stroke"
  });
}
SvgEllipse.propTypes = {
  cx: PropTypes4.number,
  cy: PropTypes4.number,
  rx: PropTypes4.number,
  ry: PropTypes4.number,
  fill: PropTypes4.string,
  fillRule: PropTypes4.string,
  mixBlendMode: blendMode_default,
  stroke: PropTypes4.string,
  strokeDasharray: PropTypes4.string,
  strokeLinecap: PropTypes4.string,
  strokeLinejoin: PropTypes4.string,
  strokeMiterlimit: PropTypes4.number,
  strokeWidth: PropTypes4.number
};
SvgEllipse.defaultProps = {
  cx: 0,
  cy: 0,
  rx: 0,
  ry: 0,
  fill: "none",
  filter: void 0,
  fillRule: void 0,
  mixBlendMode: "normal",
  stroke: "none",
  strokeDasharray: void 0,
  strokeLinecap: void 0,
  strokeLinejoin: void 0,
  strokeMiterlimit: void 0,
  strokeWidth: 0
};
var SvgEllipse_default = observer10(SvgEllipse);

// src/components/Ellipse.tsx
var Ellipse = observer11(({ clipPathId, data, globalMatrixCache }) => {
  const { id, size } = data;
  const [width, height] = size;
  const shapeProps = {
    cx: width / 2,
    cy: height / 2,
    rx: width / 2,
    ry: height / 2
  };
  return /* @__PURE__ */ React12.createElement(React12.Fragment, null, clipPathId && /* @__PURE__ */ React12.createElement("clipPath", {
    id: clipPathId
  }, /* @__PURE__ */ React12.createElement(SvgEllipse_default, __spreadValues({}, shapeProps))), /* @__PURE__ */ React12.createElement(Fills_default, __spreadValues({
    Component: SvgEllipse_default,
    fillStyle: data.fillStyle,
    id
  }, shapeProps)), /* @__PURE__ */ React12.createElement(Strokes, __spreadValues({
    Component: SvgEllipse_default,
    data,
    globalMatrixCache
  }, shapeProps)));
});

// src/components/Group.tsx
import { observer as observer12 } from "mobx-react";
import React13 from "react";
import { useComponents as useComponents3 } from "@marvelapp/design-renderer-base";
var Group = observer12((_a) => {
  var _b = _a, { data } = _b, otherProps = __objRest(_b, ["data"]);
  const { NodeList: NodeList2 } = useComponents3();
  return /* @__PURE__ */ React13.createElement(NodeList2, __spreadValues({
    nodes: data.children
  }, otherProps));
});

// src/components/Head.tsx
import React14 from "react";
import { Helmet as BaseHelmet, HelmetData } from "react-helmet-async";
var helmetData = new HelmetData({});
var Head = (props) => {
  return /* @__PURE__ */ React14.createElement(BaseHelmet, __spreadProps(__spreadValues({}, props), {
    helmetData
  }));
};

// src/components/Mask.tsx
import { observer as observer14 } from "mobx-react";
import React16 from "react";
import { useComponents as useComponents5 } from "@marvelapp/design-renderer-base";
import { useDesign as useDesign5 } from "@marvelapp/plugin-design";

// src/components/NodeContainer.tsx
import { observer as observer13 } from "mobx-react";
import React15 from "react";
import { useComponents as useComponents4 } from "@marvelapp/design-renderer-base";
import { useDesign as useDesign4 } from "@marvelapp/plugin-design";

// src/components/hooks/useGlobalMatrixScaling.ts
import { computed, runInAction } from "mobx";
import { useLocalObservable } from "mobx-react";
import { useEffect } from "react";
import { MatrixUtils as MatrixUtils3 } from "@marvelapp/design-creator";
import { useDesign as useDesign3 } from "@marvelapp/plugin-design";
function useGlobalMatrixCache(id) {
  const { getGlobalMatrix } = useDesign3();
  const cache = useLocalObservable(() => ({
    getGlobalMatrix,
    id,
    get matrix() {
      return this.getGlobalMatrix(id);
    },
    get scaling() {
      return MatrixUtils3.getScaling(this.matrix);
    }
  }), {
    matrix: computed.struct,
    scaling: computed.struct
  });
  useEffect(() => {
    runInAction(() => {
      cache.id = id;
      cache.getGlobalMatrix = getGlobalMatrix;
    });
  }, [cache, id, getGlobalMatrix]);
  return cache;
}

// src/components/NodeContainer.tsx
var NodeContainer = observer13((props) => {
  const { getItemById } = useDesign4();
  const _a = props, { data: dataOrId } = _a, otherProps = __objRest(_a, ["data"]);
  const elements = useComponents4();
  const globalMatrixCache = useGlobalMatrixCache(typeof dataOrId === "string" ? dataOrId : dataOrId.id);
  const data = typeof dataOrId === "string" ? getItemById(dataOrId) : dataOrId;
  if (!data)
    return null;
  return /* @__PURE__ */ React15.createElement(elements.Node, __spreadProps(__spreadValues({}, otherProps), {
    data,
    globalMatrixCache
  }));
});

// src/components/Mask.tsx
var Mask = observer14((_a) => {
  var _b = _a, { data } = _b, otherProps = __objRest(_b, ["data"]);
  const { NodeList: NodeList2 } = useComponents5();
  const { getItemById } = useDesign5();
  const clipNode = getItemById(data.children[0]);
  if (!clipNode)
    return null;
  const clipPathId = `clipPath-${data.id}`;
  return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(NodeContainer, __spreadValues({
    clipPathId,
    data: clipNode,
    key: clipNode.id
  }, otherProps)), /* @__PURE__ */ React16.createElement("g", {
    clipPath: `url(#${clipPathId})`
  }, /* @__PURE__ */ React16.createElement(NodeList2, __spreadValues({
    nodes: data.children
  }, otherProps))));
});

// src/components/Node.tsx
import { observer as observer17 } from "mobx-react";
import React19 from "react";
import { MatrixUtils as MatrixUtils4 } from "@marvelapp/design-creator";
import { useComponents as useComponents6 } from "@marvelapp/design-renderer-base";

// src/components/draw/BlurFilter.tsx
import { observer as observer15 } from "mobx-react";
import React17 from "react";
function hasBlur(data) {
  return data.itemProps.blur > 0;
}
var BlurFilter = observer15(({ data, id: blurId }) => {
  if (!hasBlur(data))
    return null;
  return /* @__PURE__ */ React17.createElement("filter", {
    height: "200%",
    id: blurId,
    width: "200%",
    x: "-50%",
    y: "-50%"
  }, /* @__PURE__ */ React17.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: data.blur
  }));
});

// src/components/draw/ShadowFilter.tsx
import { observer as observer16 } from "mobx-react";
import React18 from "react";
import { ColorUtils as ColorUtils2 } from "@marvelapp/design-creator";
function hasShadow(data) {
  return data.shadows && data.shadows.filter(isVisible).length > 0;
}
var ShadowFilter = observer16(({ data, id: shadowId }) => {
  if (!hasShadow(data))
    return null;
  const shadowDefs = data.shadows.map((shadow, i2) => {
    if (!isVisible(shadow))
      return null;
    const [dx, dy] = shadow.offset;
    const [r2, g2, b2, a2] = ColorUtils2.getRgba(shadow.color);
    const inside = i2 === 0 ? "BackgroundImageFix" : `dropShadow${i2 - 1}`;
    const out = `dropShadow${i2}`;
    return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /* @__PURE__ */ React18.createElement("feOffset", {
      dx,
      dy
    }), /* @__PURE__ */ React18.createElement("feGaussianBlur", {
      stdDeviation: shadow.blur / 2
    }), /* @__PURE__ */ React18.createElement("feColorMatrix", {
      type: "matrix",
      values: `0 0 0 0 ${r2} 0 0 0 0 ${g2} 0 0 0 0 ${b2} 0 0 0 ${a2} 0`
    }), /* @__PURE__ */ React18.createElement("feBlend", {
      in2: inside,
      mode: "normal",
      result: out
    }));
  });
  return /* @__PURE__ */ React18.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "objectBoundingBox",
    height: "200%",
    id: shadowId,
    width: "200%",
    x: "-50%",
    y: "-50%"
  }, /* @__PURE__ */ React18.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), shadowDefs, /* @__PURE__ */ React18.createElement("feBlend", {
    in: "SourceGraphic",
    in2: `dropShadow${shadowDefs.length - 1}`,
    mode: "normal",
    result: "shape"
  }));
});
function isVisible(shadow) {
  if (!shadow.enabled)
    return false;
  const [x2, y2] = shadow.offset;
  if (shadow.blur === 0 && x2 === 0 && y2 === 0 && shadow.shadowSpread === 0)
    return false;
  return true;
}

// src/components/Node.tsx
var Node = observer17((props) => {
  const { data, noPointerEvents, globalMatrixCache } = props;
  const { className, itemProps } = data;
  const { opacity, matrix } = itemProps;
  const elements = useComponents6();
  const Element = elements[className];
  if (!Element)
    return null;
  return /* @__PURE__ */ React19.createElement(WithFilters, {
    data,
    globalMatrixCache
  }, /* @__PURE__ */ React19.createElement("g", {
    opacity,
    style: {
      mixBlendMode: itemProps.blendMode,
      pointerEvents: noPointerEvents ? "none" : "all"
    },
    transform: `matrix(${matrix.join(" ")})`
  }, /* @__PURE__ */ React19.createElement(Element, __spreadValues({}, props))));
});
function WithFilters({ children, data, globalMatrixCache }) {
  const { id } = data;
  const blurId = hasBlur(data) ? `${id}-blur` : null;
  const shadowId = hasShadow(data) ? `${id}-shadow` : null;
  const filterUrl = [shadowId, blurId].map((filterId) => filterId ? `url(#${filterId})` : "").join(" ").trim();
  if (!filterUrl)
    return children;
  const globalMatrix = globalMatrixCache.matrix;
  const inverseGlobalMatrix = MatrixUtils4.invert(globalMatrixCache.matrix);
  return /* @__PURE__ */ React19.createElement(React19.Fragment, null, filterUrl && /* @__PURE__ */ React19.createElement("defs", null, /* @__PURE__ */ React19.createElement(BlurFilter, {
    data,
    id: blurId
  }), /* @__PURE__ */ React19.createElement(ShadowFilter, {
    data,
    id: shadowId
  })), /* @__PURE__ */ React19.createElement("g", {
    filter: !filterUrl ? void 0 : filterUrl,
    transform: `matrix(${inverseGlobalMatrix.join(" ")})`
  }, /* @__PURE__ */ React19.createElement("g", {
    transform: `matrix(${globalMatrix.join(" ")})`
  }, children)));
}

// src/components/NodeList.tsx
import { observer as observer18 } from "mobx-react";
import React20 from "react";
var NodeList = observer18((_a) => {
  var _b = _a, { nodes } = _b, otherProps = __objRest(_b, ["nodes"]);
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, nodes.map((nodeOrId) => /* @__PURE__ */ React20.createElement(NodeContainer, __spreadProps(__spreadValues({}, otherProps), {
    data: nodeOrId,
    key: typeof nodeOrId === "string" ? nodeOrId : nodeOrId.id
  }))));
});

// src/components/Raster.tsx
import { observer as observer21 } from "mobx-react";
import React23 from "react";
import {
  ItemUtils as ItemUtils2,
  PointUtils as PointUtils4,
  RasterUtils
} from "@marvelapp/design-creator";

// src/components/SVG.tsx
import { observer as observer19 } from "mobx-react";
import React21 from "react";
import { FillUtils as FillUtils2 } from "@marvelapp/design-creator";
var SVG = observer19(({ data, url }) => {
  const { id, size } = data;
  const [width, height] = size;
  const fill = data.fillStyle.fills[0];
  const isColorFill = fill && FillUtils2.isColorFill(fill);
  return /* @__PURE__ */ React21.createElement(React21.Fragment, null, url && /* @__PURE__ */ React21.createElement("g", {
    display: isColorFill ? "none" : "block"
  }, /* @__PURE__ */ React21.createElement("image", {
    height,
    href: url,
    id,
    preserveAspectRatio: "none",
    width
  })), isColorFill && renderIconFill(id, fill));
});
function renderIconFill(id, fill) {
  const [r2, g2, b2, a2] = fill.content.rgbaValues;
  const matrix = `
    0 0 0 0 ${r2}
    0 0 0 0 ${g2}
    0 0 0 0 ${b2}
    0 0 0 ${a2} 0`;
  return /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement("filter", {
    id: `${id}-fill`
  }, /* @__PURE__ */ React21.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: matrix
  })), /* @__PURE__ */ React21.createElement("use", {
    filter: `url(#${id}-fill)`,
    href: `#${id}`
  }));
}

// src/components/draw/RoundedRect.tsx
import { observer as observer20 } from "mobx-react";
import React22 from "react";
import { PointUtils as PointUtils3 } from "@marvelapp/design-creator";
var RoundedRect = observer20((_a) => {
  var _b = _a, { radius } = _b, props = __objRest(_b, ["radius"]);
  const { globalMatrixCache, width, height } = props;
  const rectHasDifferingRadii = !radius.every((radii) => radii === radius[0]);
  const shapeProps = props;
  const strokeAdjustedRectangle = useStrokeAdjustedRectangle();
  const inverseGlobalScaling = PointUtils3.reciprocal(globalMatrixCache.scaling);
  if (rectHasDifferingRadii) {
    const { x: x2, y: y2, strokePosition, strokeWidth } = props;
    const {
      x: adjustedX,
      y: adjustedY,
      width: adjustedWidth,
      height: adjustedHeight,
      radius: adjustedRadius
    } = strokeAdjustedRectangle({
      x: x2,
      y: y2,
      width,
      height,
      globalMatrixCache,
      radius,
      strokePosition,
      strokeWidth
    });
    shapeProps.d = createPathString({
      w: adjustedWidth,
      h: adjustedHeight,
      x: adjustedX,
      y: adjustedY,
      radius: adjustedRadius,
      scale: inverseGlobalScaling
    });
  } else {
    shapeProps.rx = radius[0] * inverseGlobalScaling[0];
    shapeProps.ry = radius[0] * inverseGlobalScaling[1];
  }
  const SvgComponent = rectHasDifferingRadii ? SvgPath_default : SvgRect_default;
  return /* @__PURE__ */ React22.createElement(SvgComponent, __spreadValues({}, shapeProps));
});

// src/components/Raster.tsx
var Raster = observer21(({ data, globalMatrixCache }) => {
  const { id, radius, size } = data;
  const [width, height] = size;
  const getUrlAlias = useGetUrlAlias();
  const url = getUrlAlias(id, data.source);
  if (RasterUtils.getFormat(data) === "svg") {
    return /* @__PURE__ */ React23.createElement(SVG, {
      data,
      url
    });
  }
  const cappedRadius = capRadius(radius, PointUtils4.multiply(size, globalMatrixCache.scaling));
  const shapeProps = {
    width,
    height,
    x: 0,
    y: 0,
    radius: cappedRadius,
    globalMatrixCache
  };
  return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("clipPath", {
    id: `clip-path-id-${id}`
  }, /* @__PURE__ */ React23.createElement(RoundedRect, __spreadValues({}, shapeProps))), url && /* @__PURE__ */ React23.createElement("image", {
    clipPath: `url(#clip-path-id-${id})`,
    height,
    href: url,
    opacity: ItemUtils2.getOpacity(data),
    preserveAspectRatio: "none",
    width
  }), /* @__PURE__ */ React23.createElement(Fills_default, __spreadValues({
    Component: RoundedRect,
    fillStyle: data.fillStyle,
    id
  }, shapeProps)), /* @__PURE__ */ React23.createElement(Strokes, __spreadValues({
    Component: RoundedRect,
    data
  }, shapeProps)));
});

// src/components/Rectangle.tsx
import { observer as observer22 } from "mobx-react";
import React24 from "react";
import { PointUtils as PointUtils5 } from "@marvelapp/design-creator";
var Rectangle = observer22(({ clipPathId, data, globalMatrixCache }) => {
  const { id, radius, size } = data;
  const [width, height] = size;
  const cappedRadius = capRadius(radius, PointUtils5.multiply(size, globalMatrixCache.scaling));
  const shapeProps = {
    width,
    height,
    x: 0,
    y: 0,
    radius: cappedRadius
  };
  return /* @__PURE__ */ React24.createElement(React24.Fragment, null, clipPathId && /* @__PURE__ */ React24.createElement("clipPath", {
    id: clipPathId
  }, /* @__PURE__ */ React24.createElement(RoundedRect, __spreadValues({}, shapeProps))), /* @__PURE__ */ React24.createElement(Fills_default, __spreadValues({
    Component: RoundedRect,
    fillStyle: data.fillStyle,
    globalMatrixCache,
    id
  }, shapeProps)), /* @__PURE__ */ React24.createElement(Strokes, __spreadValues({
    Component: RoundedRect,
    data,
    globalMatrixCache
  }, shapeProps)));
});

// src/components/Shape.tsx
import { observer as observer23 } from "mobx-react";
import React25 from "react";
import { ShapeType } from "@marvelapp/design-creator";
import { useComponents as useComponents7 } from "@marvelapp/design-renderer-base";
var Shape = observer23((props) => {
  const { Rectangle: Rectangle2, Ellipse: Ellipse2 } = useComponents7();
  switch (props.data.type) {
    case ShapeType.Rectangle:
      return /* @__PURE__ */ React25.createElement(Rectangle2, __spreadProps(__spreadValues({}, props), {
        data: props.data
      }));
    case ShapeType.Ellipse:
      return /* @__PURE__ */ React25.createElement(Ellipse2, __spreadProps(__spreadValues({}, props), {
        data: props.data
      }));
    default:
      return null;
  }
});

// src/components/Text.tsx
import { observer as observer24 } from "mobx-react";
import React28, { useRef as useRef2 } from "react";
import { ItemUtils as ItemUtils3, SizeUtils, TextUtils } from "@marvelapp/design-creator";
import { useFonts as useFonts3 } from "@marvelapp/plugin-fonts";

// src/components/hooks/useFontLoaded.ts
import FontFaceObserver from "fontfaceobserver";
import React26 from "react";
import { FontUtils } from "@marvelapp/design-creator";
import { useFonts as useFonts2 } from "@marvelapp/plugin-fonts";
var fontObservers = {};
function useFontLoaded({
  fontFamily: fontDescriptor,
  fontWeight,
  fontStyle
}) {
  const { getFontFaces } = useFonts2();
  const fontFamily = FontUtils.getFontFamily(getFontFaces(), fontDescriptor);
  const [, forceUpdate] = React26.useState(false);
  if (fontFamily === null) {
    return true;
  }
  const fontVariant = `${fontFamily};${fontStyle};${fontWeight}`;
  const fontObserver = fontObservers[fontVariant] || {
    done: false,
    promise: new FontFaceObserver(fontFamily, {
      weight: fontWeight,
      style: fontStyle
    }).load()
  };
  fontObservers[fontVariant] = fontObserver;
  if (fontObserver.done) {
    return true;
  }
  fontObserver.promise.finally(() => {
    fontObservers[fontVariant].done = true;
    forceUpdate((n2) => !n2);
  });
  return false;
}

// src/components/hooks/useUpdateListener.tsx
import React27, {
  createContext as createContext2,
  useCallback as useCallback2,
  useContext as useContext2,
  useEffect as useEffect2,
  useLayoutEffect,
  useReducer,
  useRef
} from "react";
var UpdateListenerContext = createContext2([]);
function useUpdateListener(on = true, predicate = () => true) {
  const [n2, forceUpdate] = useReducer((x2) => x2 + 1, 0);
  const updateListeners = useContext2(UpdateListenerContext);
  useEffect2(() => {
    if (!on)
      return;
    const value = { forceUpdate, predicate };
    updateListeners.push(value);
    return () => {
      updateListeners.splice(updateListeners.indexOf(value), 1);
    };
  }, [updateListeners, on, predicate]);
  return n2;
}
function useNotifyUpdateListeners() {
  const updateListeners = useContext2(UpdateListenerContext);
  const notifyUpdateListeners = useCallback2(() => {
    updateListeners.forEach(({ forceUpdate, predicate }) => predicate() && forceUpdate());
  }, [updateListeners]);
  return notifyUpdateListeners;
}
function useNotifyUpdateListenersEffect(deps = []) {
  const initialRender = useRef(true);
  const notifyUpdateListeners = useNotifyUpdateListeners();
  useLayoutEffect(() => {
    if (initialRender.current === false) {
      notifyUpdateListeners();
    } else {
      initialRender.current = false;
    }
  }, [notifyUpdateListeners, ...deps]);
}
function UpdateListenerProvider({ children }) {
  const value = useRef();
  if (value.current === void 0) {
    value.current = [];
  }
  return /* @__PURE__ */ React27.createElement(UpdateListenerContext.Provider, {
    value: value.current
  }, children);
}

// src/components/Text.tsx
var TextWrapper = observer24((_a) => {
  var _b = _a, { data, globalMatrixCache, children } = _b, props = __objRest(_b, ["data", "globalMatrixCache", "children"]);
  const { id, style, size, sizing } = data;
  const prevTextStyle = useRef2(null);
  const { italic } = style;
  const fontStyle = italic ? "italic" : "normal";
  const fontLoaded = useFontLoaded(__spreadValues({ fontStyle }, style));
  useNotifyUpdateListenersEffect([fontLoaded]);
  const [width, height] = size;
  const [sizingX, sizingY] = sizing;
  const isAbsoluteX = sizingX === "absolute";
  const isAbsoluteY = sizingY === "absolute";
  const { getFontFaces } = useFonts3();
  if (isAbsoluteX && !width || isAbsoluteY && !height)
    return null;
  if (!fontLoaded && !prevTextStyle.current)
    return null;
  const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
  const actualWidth = Math.ceil(width * globalMatrixScalingX);
  const actualHeight = Math.ceil(height * globalMatrixScalingY);
  const actualSize = SizeUtils.create(actualWidth, actualHeight);
  const textStyle = !fontLoaded && prevTextStyle.current ? prevTextStyle.current : TextUtils.computeTextStylesCss(data, actualSize, getFontFaces());
  if (fontLoaded) {
    prevTextStyle.current = textStyle;
  }
  const overflow = ItemUtils3.getClientData(data).overflow ?? true;
  return /* @__PURE__ */ React28.createElement("g", {
    transform: `scale(${1 / globalMatrixScalingX}, ${1 / globalMatrixScalingY})`
  }, /* @__PURE__ */ React28.createElement("foreignObject", {
    height: actualHeight || 1,
    style: {
      overflow: overflow ? "visible" : "hidden"
    },
    width: actualWidth || 1
  }, /* @__PURE__ */ React28.createElement("div", __spreadValues({
    id,
    style: textStyle
  }, props), children)));
});
var Text = observer24((props) => {
  const { blocks, id } = props.data;
  return /* @__PURE__ */ React28.createElement(TextWrapper, __spreadValues({}, props), blocks.map(({ text }, i2) => /* @__PURE__ */ React28.createElement(Block, {
    id: i2 === blocks.length - 1 ? `${id}-end` : void 0,
    key: i2
  }, text)));
});
function Block({ children, id }) {
  return /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement("span", {
    id
  }, children || /* @__PURE__ */ React28.createElement("br", null)));
}

// src/components/context/DefaultComponentsProvider.tsx
var DefaultComponentsProvider = React29.memo(({ children }) => {
  return /* @__PURE__ */ React29.createElement(ComponentsProvider, {
    components: {
      Artboard,
      CompoundPath,
      Ellipse,
      Group,
      Head,
      Mask,
      Node,
      NodeList,
      Path,
      Raster,
      Rectangle,
      Shape,
      Text
    }
  }, children);
});

// src/components/helpers/urlAliasMap.ts
import { ItemUtils as ItemUtils4 } from "@marvelapp/design-creator";
var _map;
var UrlAliasMap = class {
  constructor() {
    __privateAdd(this, _map, void 0);
    __privateSet(this, _map, {});
  }
  set(url, localObjectUrl) {
    __privateGet(this, _map)[url] = localObjectUrl;
  }
  getUrl(itemData, url) {
    const localObjectUrl = __privateGet(this, _map)[url];
    if (localObjectUrl)
      return localObjectUrl;
    const uploaded = ItemUtils4.getUploadStatus(itemData);
    if (uploaded[url] === false)
      return;
    return url;
  }
};
_map = new WeakMap();

// src/components/hooks/useShadowRoot.ts
import { createContext as createContext3, useContext as useContext3 } from "react";
var isSSR = typeof window === "undefined";
var defaultRoot = isSSR ? void 0 : document;
var ShadowRootContext = createContext3(defaultRoot);
function useShadowRoot() {
  return useContext3(ShadowRootContext);
}

// src/components/Design.tsx
var Design = observer25(({
  children,
  noShadowDom = false,
  urlAliasMap = new UrlAliasMap()
}) => {
  const { getItemById, design, getArtboard } = useDesign6();
  const view = useView2();
  const { NodeList: NodeList2 } = useComponents8();
  const [overlayPortal, setOverlayPortal] = useState(null);
  const [shadowRootEl, setShadowRootEl] = useState(null);
  const getUrlAlias = useCallback3((itemId, url) => {
    const item = getItemById(itemId);
    if (!item)
      return url;
    return urlAliasMap.getUrl(item, url);
  }, [getItemById, urlAliasMap]);
  const [width, height] = view.bounds.size;
  const RootComponent = noShadowDom ? "div" : react_shadow_esm_default.div;
  const { zoomFactor } = view;
  const offset = PointUtils6.divide(view.offset, zoomFactor);
  return /* @__PURE__ */ React30.createElement(UpdateListenerProvider, null, /* @__PURE__ */ React30.createElement(ShadowRootContext.Provider, {
    value: (shadowRootEl == null ? void 0 : shadowRootEl.shadowRoot) ?? defaultRoot
  }, /* @__PURE__ */ React30.createElement(OverlayPortalProvider, {
    container: overlayPortal
  }, /* @__PURE__ */ React30.createElement(GetUrlAliasContext.Provider, {
    value: getUrlAlias
  }, /* @__PURE__ */ React30.createElement(Fonts, null), /* @__PURE__ */ React30.createElement(RootComponent, {
    "data-testid": "renderer-root",
    ref: setShadowRootEl
  }, /* @__PURE__ */ React30.createElement("div", {
    style: {
      transform: `scale(${zoomFactor})`,
      transformOrigin: "0px 0px"
    }
  }, /* @__PURE__ */ React30.createElement("svg", {
    height: Math.ceil(height),
    style: {
      display: "block",
      position: "absolute",
      userSelect: "none",
      pointerEvents: "none"
    },
    width: Math.ceil(width)
  }, /* @__PURE__ */ React30.createElement("g", {
    transform: `translate(${offset.join(" ")})`
  }, children, /* @__PURE__ */ React30.createElement(ArtboardContainer, {
    data: getArtboard()
  }), /* @__PURE__ */ React30.createElement(NodeList2, {
    nodes: design.root.children
  }), /* @__PURE__ */ React30.createElement("g", {
    ref: setOverlayPortal
  })))))))));
});
var DesignContainer = (props) => {
  return /* @__PURE__ */ React30.createElement(WeakViewProvider, null, /* @__PURE__ */ React30.createElement(WeakFontsProvider, null, /* @__PURE__ */ React30.createElement(DefaultComponentsProvider, null, /* @__PURE__ */ React30.createElement(Design, __spreadValues({}, props)))));
};

// src/components/helpers/measureText.tsx
import React31, { useLayoutEffect as useLayoutEffect2 } from "react";
import ReactDOM from "react-dom";
import {
  FragmentUtils,
  createEmptyDesign,
  uuid
} from "@marvelapp/design-creator";
import { ComponentOverridesProvider } from "@marvelapp/design-renderer-base";
import { DesignProvider } from "@marvelapp/plugin-design";
import { FontsProvider } from "@marvelapp/plugin-fonts";
async function unsafeMeasureText(text, fontFaces = [], timeoutMs = 5e3) {
  const container = document.createElement("div");
  const id = uuid();
  const design = createEmptyDesign();
  container.style.visibility = "hidden";
  container.style.position = "absolute";
  document.body.appendChild(container);
  FragmentUtils.mAppendItems(design, [__spreadProps(__spreadValues({}, text), { id })]);
  const size = await new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error("failed to measure text in timeout"));
    }, timeoutMs);
    function MeasuredText(props) {
      const n2 = useUpdateListener(true);
      const shadowRoot = useShadowRoot();
      useLayoutEffect2(() => {
        const measuredSize = measureTextById(id, shadowRoot);
        if (measuredSize !== null) {
          clearTimeout(timeout);
          resolve(measuredSize);
        }
      }, [n2, shadowRoot]);
      return /* @__PURE__ */ React31.createElement(Text, __spreadValues({}, props));
    }
    ReactDOM.render(/* @__PURE__ */ React31.createElement(UpdateListenerProvider, null, /* @__PURE__ */ React31.createElement(DesignProvider, {
      design
    }, /* @__PURE__ */ React31.createElement(FontsProvider, {
      options: { fontFaces }
    }, /* @__PURE__ */ React31.createElement(ComponentOverridesProvider, {
      components: { Text: MeasuredText }
    }, /* @__PURE__ */ React31.createElement(DesignContainer, null))))), container);
  });
  ReactDOM.unmountComponentAtNode(container);
  document.body.removeChild(container);
  return size;
}
function measureTextById(id, root = document) {
  const el = root.getElementById(id);
  if (!el)
    return null;
  return [
    el.offsetLeft + el.offsetWidth + 1,
    el.offsetTop + el.offsetHeight + 1
  ];
}

// src/index.ts
import { ComponentOverridesProvider as ComponentOverridesProvider2 } from "@marvelapp/design-renderer-base";
export {
  Artboard,
  ComponentOverridesProvider2 as ComponentOverridesProvider,
  CompoundPath,
  DesignContainer as Design,
  Ellipse,
  Group,
  Mask,
  Node,
  NodeList,
  Path,
  Raster,
  Rectangle,
  Shape,
  Text,
  UpdateListenerProvider,
  UrlAliasMap,
  measureTextById,
  unsafeMeasureText,
  useShadowRoot,
  useUpdateListener
};
